export const toSelectValue = (noBidReasonId, noBidReasons) =>
  noBidReasonId ? noBidReasons.filter(reason => reason.value === noBidReasonId)[0] : null

export const toSelectValues = items =>
  items.map(item => ({
    value: item.id,
    label: item.name
  }))
